import { User } from './user';

export type ReportSubscriptionType =
  | 'daily-sales-summary'
  | 'weekly-sales-summary'
  | 'monthly-sales-summary';

export type ReportSubscriptionFrequency = 'daily' | 'weekly' | 'monthly';

export const REPORT_SUBSCRIPTION_TYPES: ReportSubscriptionType[] = [
  'daily-sales-summary',
  'weekly-sales-summary',
  'monthly-sales-summary',
];

export const REPORT_SUBSCRIPTION_FREQUENCIES: ReportSubscriptionFrequency[] = [
  'daily',
  'weekly',
  'monthly',
];

export interface ReportSubscription {
  id: string;
  userId: string;
  user?: User;
  reportType: ReportSubscriptionType;
  frequency: ReportSubscriptionFrequency;
  isActive: boolean;
  createdAt: string;
  updatedAt?: string;
  // eslint-disable-next-line no-unused-vars
  onEditReportSubscription: (id: string) => void;
  // eslint-disable-next-line no-unused-vars
  onDeleteReportSubscription: (id: string) => void;
  // eslint-disable-next-line no-unused-vars
  onEditReportSubscriptionMouseEnter: (id: string) => void;
}

export interface BackendReportSubscription {
  id: string;
  user_id: string;
  user?: User;
  report_type: ReportSubscriptionType;
  frequency: ReportSubscriptionFrequency;
  is_active: boolean;
  created_at: string;
  updated_at?: string;
}

export interface ICreateReportSubscriptionDTO {
  user_id: string;
  report_type: ReportSubscriptionType;
  frequency: ReportSubscriptionFrequency;
  is_active?: boolean;
}

export interface IUpdateReportSubscriptionDTO {
  id: string;
  user_id?: string;
  report_type?: ReportSubscriptionType;
  frequency?: ReportSubscriptionFrequency;
  is_active?: boolean;
}

export interface IListReportSubscriptionsDTO {
  report_type?: ReportSubscriptionType;
  frequency?: ReportSubscriptionFrequency;
  is_active?: boolean;
}

export interface ListReportSubscriptionsParams
  extends IListReportSubscriptionsDTO {
  page?: number;
  perPage?: number;
  search?: string;
  sortBy?: string;
  sort?: string;
}

export type ListReportSubscriptionsResponse = {
  reportSubscriptions: ReportSubscription[];
  totalCount: number;
};
